export default function InputButton ({inputLabel, buttonText, onChangeInput, onClickButton, disableButtonAction, styleInput, styleButton}) {
    
    return (
        <>                                        
            <label htmlFor="smtp_senha">{inputLabel}</label>
            <div className='input-button'>
                <input
                    onChange={onChangeInput}
                    style={styleInput}
                />
                
                <button
                    onClick={onClickButton}
                    disabled={disableButtonAction}
                    style={styleButton}
                >
                    {buttonText}
                </button>
            </div>
        </>
    )
}